import { Button, Stack, styled, Typography } from "@mui/material";
import { DateTime } from "luxon";
import { MeetingTimer } from "src/components";
import { Links, MeetingType } from "src/constants";
import { OneOnOneMeetingNotificationDto, TeamMeetingNotificationDto } from "src/http";

const MeetingNotificationContainer = styled(Stack)`
  background-color: #ceedff;
  border-radius: 8px;
  padding: 10px 20px;
  justify-content: space-between;
`;

interface Props {
  meeting: OneOnOneMeetingNotificationDto | TeamMeetingNotificationDto;
}

const MeetingNotification = (props: Props) => {
  const { meeting } = props;

  return (
    <MeetingNotificationContainer direction="row" spacing={1}>
      <Stack>
        <Typography variant="body2" component="span" sx={{ whiteSpace: "nowrap" }}>
          {meeting.type === MeetingType.OneOnOne ? `1:1 Meeting` : meeting.title}
        </Typography>
        <Typography component="span" sx={{ whiteSpace: "nowrap" }}>
          {meeting.type === MeetingType.OneOnOne
            ? `${meeting.leadUser.displayName} & ${meeting.otherUser.displayName} meeting is in progress.`
            : `${meeting.team.name} meeting is in progress.`}
        </Typography>
        <Typography variant="caption">
          {"Running time "}
          <MeetingTimer
            startDateTimeUtc={DateTime.fromISO(meeting.currentInstance!.startedAtDateTimeUtc, { zone: "utc" })}
          />
        </Typography>
      </Stack>
      <Button variant="outlined" href={Links.Meeting(meeting.guid)} sx={{ alignSelf: "center", whiteSpace: "nowrap" }}>
        Join Meeting
      </Button>
    </MeetingNotificationContainer>
  );
};

export { MeetingNotification };
